/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

import { BalloonInfoActions, EBalloonInfoActions } from '../actions';
import { IVideoDeviceInfoState, initialDeviceInfoState } from '../state/video-device-info.state';

export function videoDeviceInfoReducer(state = initialDeviceInfoState, action: BalloonInfoActions): IVideoDeviceInfoState {
  switch (action.type) {
    case EBalloonInfoActions.GetVideoDeviceInfo: {
      return {
        ...state
      };
    }

    case EBalloonInfoActions.GetVideoDeviceInfoSuccess: {
      return {
        ...state,
        earliestRecordingUTC: action.payload.earliestRecordingUTC,
        online: action.payload.online,
        isVodRequestEnabled: action.payload.isVodRequestEnabled
      };
    }

    case EBalloonInfoActions.GetVideoDeviceInfoError: {
      return {
        ...initialDeviceInfoState
      };
    }

    default:
      return state;
  }
}
